// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__aime_747932', '__aime_Fallback_747932'"},"className":"__className_747932","variable":"__variable_747932"};